export default class BaseModel {
  static cleanParam(name = '') {
    if (!name) {
      return '';
    }

    return name.replace(/ /g, '-').split('?')[0];
  }
}
